import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { Mapper, MapperParams } from '@products/utils/mappers/type.mapper';
import {
  ConfigurationCountry,
  ConfigurationLocale,
  FundId,
  ShareClassCode,
} from '@types';
import { IndexPerformanceDTO } from '../dto/indexes.dto.types';
import { IndexPerformance } from '../model/indexes';

export class IndexPerformanceMapper extends Mapper<IndexPerformance> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(indexPerformanceDTO: IndexPerformanceDTO): IndexPerformance {
    return {
      fundId: indexPerformanceDTO.fundid as FundId,
      shareClassCode: indexPerformanceDTO.shclcode as ShareClassCode,
      countryCode: indexPerformanceDTO.cntrycode as ConfigurationCountry,
      languageCode: indexPerformanceDTO.langcode as ConfigurationLocale,
      indexName: indexPerformanceDTO.indexname,
      asOfDate: indexPerformanceDTO.asofdate,
      dailyLevel: indexPerformanceDTO.dailylevel,
      dailyChangeValue: indexPerformanceDTO.dailychangevalue,
      dailyChangePercent: indexPerformanceDTO.dailychangepct,
      monthToDateReturn: indexPerformanceDTO.mtdreturn,
      monthToDateStartDate: indexPerformanceDTO.mtdstartdate,
      quarterToDateReturn: indexPerformanceDTO.qtdreturn,
      quarterToDateStartDate: indexPerformanceDTO.qtdstartdate,
      yearToDateReturn: indexPerformanceDTO.ytdreturn,
      yearToDateStartDate: indexPerformanceDTO.ytdstartdate,
      return1Year: indexPerformanceDTO.return1yr,
      startDate1Year: indexPerformanceDTO.startdate1yr,
      return2Year: indexPerformanceDTO.return2yr,
      startDate2Year: indexPerformanceDTO.startdate2yr,
      return3Year: indexPerformanceDTO.return3yr,
      startDate3Year: indexPerformanceDTO.startdate3yr,
      return5Year: indexPerformanceDTO.return5yr,
      startDate5Year: indexPerformanceDTO.startdate5yr,
      return7Year: indexPerformanceDTO.return7yr,
      startDate7Year: indexPerformanceDTO.startdate7yr,
      return10Year: indexPerformanceDTO.return10yr,
      startDate10Year: indexPerformanceDTO.startdate10yr,
      returnSinceInception: indexPerformanceDTO.returnsi,
      startDateSinceInception: indexPerformanceDTO.startdatesi,
    };
  }
}
